import IconSorting from "../../data/Icons/leon-inmobiliaria-icons-sortieren.svg";
import IconFiltering from "../../data/Icons/leon-inmobiliaria-icons-filter.svg";
import {useRouter} from "next/router";
import {useState} from "react";
import {enforceArray, handleSort, sortingOption} from "../../helpers/FilterFunctions";
import {VermietungSortingOptions} from "../../data/Filter/VermietungFilter.config";
import {VerkaufSortingOptions} from "../../data/Filter/VerkaufFilter.config";
import {useTranslation} from "next-i18next";

interface MobileFilterBarPropsInterface {
	onOpenFilterMenu: () => void;
}

function SortingOptions(props: {
	options: sortingOption[];
	open: boolean;
	onClick: () => void;
}) {
	const router = useRouter();
	const {t} = useTranslation();
	if (!props.open) return <></>;
	return (
		<div className="flex flex-col items-start absolute w-max bg-white top-full text-leo-button-gray px-[45px] py-2 gap-2">
			{props.options.map((o) => (
				<button
					key={"mobile-" + o.label}
					onClick={() => {
						handleSort(
							enforceArray({name: o.label}),
							router.asPath.includes("verkauf")
								? VerkaufSortingOptions
								: VermietungSortingOptions,
							router
						);
						props.onClick();
					}}
				>
					{t(o.label)}
				</button>
			))}
		</div>
	);
}

export default function MobileFilterBar(props: MobileFilterBarPropsInterface) {
	const [showSortingOptions, setShowSortingOptions] = useState(false);
	const {t} = useTranslation();

	return (
		<div className="bg-leo-dark-brown xl:hidden items-center flex w-screen  py-2 justify-between h-8 text-white relative">
			<button onClick={() => setShowSortingOptions(!showSortingOptions)}>
				<div className="flex items-center gap-2 px-4">
					<div className="h-5 w-5">
						<IconSorting/>
					</div>
					<span>{t("components.mobileFilterBar.sort")}</span>
				</div>
			</button>

			<button onClick={props.onOpenFilterMenu}>
				<div className="flex items-center gap-2 px-4">
					<div className="h-5 w-5">
						<IconFiltering/>
					</div>
					<span>{t("components.mobileFilterBar.filter")}</span>
				</div>
			</button>
			<SortingOptions
				options={VermietungSortingOptions}
				open={showSortingOptions}
				onClick={() => setShowSortingOptions(false)}
			/>
		</div>
	);
}
